export default {
	type: 'object',
	properties: {
		projectUrl: { type: 'string' },
		lastKey: { type: 'string' },
	},
	required: ['projectUrl'],
	additionalProperties: true,
}
